import type { MetaFunction } from '@remix-run/node';
import { FAQSection } from '~/components/faqs/FAQSection';
import { useRootLoader } from '~/utils/use-root-loader';

export const meta: MetaFunction = () => [
  { title: 'Frequently Asked Questions' },
  {
    name: 'description',
    content:
      'Answers to common questions about KTM Vape products, shipping, returns, and support.',
  },
];

export default function FAQPage() {
  const rootData = useRootLoader();
  const faqs = rootData?.faqs ?? [];

  return (
    <div className="min-h-screen p-6">
      <FAQSection faqs={faqs} />
    </div>
  );
}
